/* eslint-disable prettier/prettier */
import Splide from '@splidejs/splide';
import Swiper from 'swiper';
import { Navigation, Scrollbar, EffectCoverflow, Pagination } from 'swiper/modules';
export const initTimeline = () => {
    /**
     * Splide slider on mobile
     */
    const timelineBlock = document.querySelector(".timeline-block") as HTMLElement;
    function duplicateSlidesForLoop(containerSelector: string, minSlides: number) {
        const container = document.querySelector(containerSelector) as HTMLElement | null;
        if (!container) return;

        const wrapper = container.querySelector(".swiper-wrapper") as HTMLElement | null;
        if (!wrapper) return;

        const originals = Array.from(wrapper.children).filter((el) =>
            (el as HTMLElement).classList.contains("swiper-slide")
        );

        if (originals.length === 0) return;

        while (wrapper.querySelectorAll(".swiper-slide").length < minSlides) {
            for (const s of originals) wrapper.appendChild(s.cloneNode(true));
        }
    }
    if (timelineBlock) {

   
        duplicateSlidesForLoop(".swiper", 5);

        const swiper = new Swiper(".swiper", {
            modules: [Scrollbar, Navigation, EffectCoverflow, Pagination],
            effect: 'coverflow',
            centeredSlides: true,
            grabCursor: true,

            slidesPerView: 1,
            spaceBetween: 100,
            coverflowEffect: {
                rotate: 0,
                stretch: 0,
                depth: 100,
                modifier: 1.5
            },
            loop: true,
            slidesPerGroup: 1,
            // H�ll den l�g. F�r stora v�rden kan ocks� st�lla till det i vissa versioner.
            loopAdditionalSlides: 2,

            watchSlidesProgress: true, // brukar hj�lpa 3D-effekter/centered

            breakpoints: {
                640: { slidesPerView: 2 },
                1024: { slidesPerView: 1.5 },
            },

            keyboard: { enabled: true },
            mousewheel: { thresholdDelta: 70 },
            pagination: {
                el: ".swiper-pagination",
                type: "progressbar",
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
                enable: true,

            },
            scrollbar: {
                el: '.swiper-scrollbar',
                hide: true,
            },
        });

        swiper.update();
        swiper.loopCreate();


    }
}
    /*swiper.slideTo(1, false, false);*/

    //if (timelineBlock) {
    //    /*var splide = new Splide('#timeline-carousel');*/
    //    var bar = document.querySelector(".my-slider-progress-bar") as HTMLElement;
    //    var splide = new Splide('#timeline-carousel', {
    //        type: 'loop',
    //        perPage: 1,
    //        pagination: false,
    //        focus: 'center',
    //        throttle: 300,
    //        omitEnd: true,
    //        autowidth: true,
    //        autoHeight: true,
    //        padding: '20%',
            
    //        reducedMotion: {
    //            speed: 0,
    //            rewindSpeed: 0,
    //        },


    //    });
    //    if (bar) {

    //        splide.on('mounted move', function () {
    //            var end = splide.Components.Controller.getEnd() + 1;
    //            var rate = Math.min((splide.index + 1) / end, 1);
    //            bar.style.width = String(100 * rate) + '%';
    //        });

    //        splide.mount();
    //    }
    //}

  
    // const updatePaginationText = () => {
    //   const splidePaginationPages = document.querySelectorAll(".splide__pagination__page");
    //   const maxNumber = splidePaginationPages.length;
    
    //   splidePaginationPages.forEach((page, index) => {
    //    page.textContent = `${index + 1} / ${maxNumber} slides`;
    //   });
    // };

    // const paginationElement = document.querySelector('.splide__pagination');
    // const paginationArrows = document.querySelector('.splide__arrows');

    // const hideArrows = () => {
    //   if (paginationArrows) {
    //     paginationArrows.classList.toggle("hide");
    //   }
    // }

    // if (paginationElement && getComputedStyle(paginationElement).display !== 'none') {
    //   updatePaginationText();
    // } else {
    //   hideArrows();
    //   window.addEventListener('resize', hideArrows);
    // }
    
    // window.addEventListener("resize", updatePaginationText);
  
